import { IconButton, Toolbar } from '@material-ui/core';

import AppBar from '@material-ui/core/AppBar';
import { Navigate } from 'react-router-dom';
import ParameterListener from '../Parameters';
import React from 'react';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Tooltip from '../../common/StyledToolTip';
import appConstants from '../../../appConstants';
import { compose } from 'recompose';
import styles from '../headerStyles';
import { withFeatureFlags } from '../../../userProfile/featureFlagsContext';
import withRouter from '../../../routes/withRouter';
import { withStyles } from '@material-ui/core/styles';
import { withUserProfile } from '../../../userProfile/userProfileContext';

class CustomHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTabValue: this.props.router.location.pathname
        ? this.props.router.location.pathname.toLowerCase()
        : false
    };
  }

  handleChange = (event, value) => {
    this.setState({
      currentTabValue: value
    });
  };

  render() {
    const { classes, customTabInfo, isEnabled = true} = this.props;
    if (!isEnabled) {
      return <Navigate to={appConstants.NAV_URLS.PAGE_NOT_FOUND} />;
    }
    return (
      <div>
        {this.state.currentTabValue &&
          this.state.currentTabValue != this.props.router.location.pathname && (
            <Navigate to={this.state.currentTabValue} />
          )}
        <AppBar position="sticky" className="appHeader" classes={{ root: classes.headerStyles }}>
          <Toolbar variant="dense" classes={{ gutters: classes.gutters }}>
            <img
              className={classes.shipmentSelectionRmaxLogo}
              src="../../images/RouteMax_Logo_Orange_v2.svg"
            />
            <Tabs
              value={
                [customTabInfo.path].includes(this.state.currentTabValue)
                  ? this.state.currentTabValue
                  : false
              }
              classes={{
                root: classes.tabsRoot,
                indicator: classes.tabsIndicator
              }}
              onChange={this.handleChange}>
              <Tab
                value={customTabInfo.path}
                label={customTabInfo.label}
                id={customTabInfo.id}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected
                }}
              />
            </Tabs>
            <div className={classes.grow}></div>
            <div className={classes.headerIcons}></div>
            <div className={`${classes.muiIconContainer} ${classes.headerIconStyles}`}>
              <IconButton
                color="inherit"
                className={classes.muiIconButtonStyle}
                onClick={(e) => this.handleChange(e, '/settings')}
                data-automationid="settings-icon">
                <Tooltip title="Application Settings">
                  <SettingsIcon />
                </Tooltip>
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <ParameterListener scenarioId={this.props.userData.userProfile.scenarioID} />
      </div>
    );
  }
}
export default compose(
  withStyles(styles),
  withUserProfile,
  withFeatureFlags,
  withRouter
)(CustomHeader);
